<template>
    <div>
        <b-modal
            id="modify-customer-verification-popup"
            ref="modal"
            title="Customer Verification"
            size="lg"
            hide-footer
            modal-class="hide-footer"
            no-close-on-backdrop
            :hide-header-close="loading"
            no-close-on-esc
            @hidden="onHidden"
        >
            <b-form
                @submit.stop.prevent="onSubmit()"
                @reset.stop.prevent="onHidden"
            >
                <div class="row custom-model-form">
                    <div class="col-md-8">
                        <b-form-group label="ID Document Verification">
                            <!-- :label-for="formData.factor" -->
                            <b-form-select
                                v-model="formData.verification"
                                :options="options"
                                placeholder="Select an Option"
                                v-validate="{
                                    required: false,
                                }"
                                class="form-control"
                                name="ID Verification"
                                :class="{
                                    'is-invalid': errors.has(
                                        'ID Verification Status'
                                    ),
                                }"
                            ></b-form-select>
                            <em>{{formData.idVerificationDate | moment('MM-DD-YYYY HH:MM ')}}</em>

                        </b-form-group>
                    </div>
                    <div  class="col-md-4">
                        <base-file-input style="margin-bottom: 1px !important;"
                                inputLabel="Upload File"
                                :ref="idVerificationFile"
                                v-model="formData.idVerificationFile"
                                file-type="customers"
                                accept="image/*, application/pdf"
                                v-validate="{
                                    required: false,
                                }"
                                :required="false"
                                :placeholder="formData.idVerificationFile"
                                name="Criminal Record Verification File"
                        ></base-file-input>
                        <a v-if="formData.idVerificationFile" @click="openPopup(formData.idVerificationFile)">Preview</a>

                    </div>
                    <div class="col-md-8">
                        <b-form-group label="License Document Verification">
                            <!-- :label-for="formData.factor" -->
                            <b-form-select
                                v-model="formData.licenseVerification"
                                :options="options"
                                placeholder="Select an Option"
                                v-validate="{
                                    required: false,
                                }"
                                class="form-control"
                                name="License Verification"
                                :class="{
                                    'is-invalid': errors.has(
                                        'License Verification Status'
                                    ),
                                }"
                            ></b-form-select>
                            <em>{{formData.licenseVerificationDate | moment('MM-DD-YYYY HH:MM ')}}</em>

                        </b-form-group>
                    </div>
                    <div  class="col-md-4">
                        <base-file-input style="margin-bottom: 1px !important;"
                                inputLabel="Upload File"
                                :ref="licenseVerificationFile"
                                v-model="formData.licenseVerificationFile"
                                file-type="customers"
                                accept="image/*, application/pdf"
                                v-validate="{
                                    required: false,
                                }"
                                :required="false"
                                :placeholder="formData.licenseVerificationFile"
                                name="Criminal Record Verification File"
                        ></base-file-input>
                        <a v-if="formData.licenseVerificationFile" @click="openPopup(formData.licenseVerificationFile)">Preview</a>

                    </div>
                    <div class="col-md-8">
                        <b-form-group label="Degree Verification">
                            <!-- :label-for="formData.factor" -->
                            <b-form-select
                                    v-model="formData.degreeVerification"
                                    :options="options3"
                                    placeholder="Select an Option"
                                    v-validate="{
                                    required: false,
                                }"
                                    class="form-control"
                                    name="Degree Verification"
                                    :class="{
                                    'is-invalid': errors.has(
                                        'Degree Verification'
                                    ),
                                }"
                            ></b-form-select>
                            <em>{{formData.degreeVerificationDate | moment('MM-DD-YYYY HH:MM ')}}</em>

                        </b-form-group>
                    </div>
                    <div  class="col-md-4">
                        <base-file-input style="margin-bottom: 1px !important;"
                                inputLabel="Upload File"
                                :ref="degreeFile"
                                v-model="formData.degreeFile"
                                file-type="customers"
                                accept="image/*, application/pdf"
                                v-validate="{
            required: false,
        }"
                                :required="false"
                                :placeholder="formData.degreeFile"
                                name="Criminal Record Verification File"
                        ></base-file-input>
                        <a v-if="formData.degreeFile" @click="openPopup(formData.degreeFile)">Preview</a>

                    </div>
                    <div class="col-md-12">
                        <b-form-group label="Employment Verification">
                            <!-- :label-for="formData.factor" -->
                            <b-form-select
                                    v-model="formData.employmentVerification"
                                    :options="options4"
                                    placeholder="Select an Option"
                                    v-validate="{
                                    required: false,
                                }"
                                    class="form-control"
                                    name="Employment Verification"
                                    :class="{
                                    'is-invalid': errors.has(
                                        'Employment Verification'
                                    ),
                                }"
                            ></b-form-select>
                            <em>{{formData.employmentVerificationDate | moment('MM-DD-YYYY HH:MM ')}}</em>

                        </b-form-group>
                    </div>
                    <div class="col-md-4 pb-3">
                        <base-file-input style="margin-bottom: 1px !important;"
                                inputLabel="Upload File"
                                :ref="employmentFile"
                                v-model="formData.employmentFile"
                                file-type="customers"
                                accept="image/*, application/pdf"
                                v-validate="{
            required: false,
        }"
                                :required="false"
                                :placeholder="formData.employmentFile"
                                name="Criminal Record Verification File"
                        ></base-file-input>
                        <a v-if="formData.employmentFile" @click="openPopup(formData.employmentFile)">Preview</a>

                    </div>
                    <div class="col-md-4 pb-3">
                        <base-file-input style="margin-bottom: 1px !important;"
                                inputLabel="Upload File"
                                :ref="employmentFile2"
                                v-model="formData.employmentFile2"
                                file-type="customers"
                                accept="image/*, application/pdf"
                                v-validate="{
            required: false,
        }"
                                :required="false"
                                :placeholder="formData.employmentFile2"
                                name="Criminal Record Verification File"
                        ></base-file-input>
                        <a v-if="formData.employmentFile2" @click="openPopup(formData.employmentFile2)">Preview</a>

                    </div>
                    <div class="col-md-4 pb-3">
                        <base-file-input style="margin-bottom: 1px !important;"
                                inputLabel="Upload File"
                                :ref="employmentFile3"
                                v-model="formData.employmentFile3"
                                file-type="customers"
                                accept="image/*, application/pdf"
                                v-validate="{
            required: false,
        }"
                                :required="false"
                                :placeholder="formData.employmentFile3"
                                name="Criminal Record Verification File"
                        ></base-file-input>
                        <a v-if="formData.employmentFile3" @click="openPopup(formData.employmentFile3)">Preview</a>

                    </div>
                    <div class="col-md-8">
                        <b-form-group label="Criminal Record Verification">
                            <!-- :label-for="formData.factor" -->
                            <b-form-select
                                v-model="formData.verificationCriminal"
                                :options="options2"
                                placeholder="Select an Option"
                                v-validate="{
                                    required: false,
                                }"
                                class="form-control"
                                name="Criminal Record Verification"
                                :class="{
                                    'is-invalid': errors.has(
                                        'Criminal Record Verification'
                                    ),
                                }"
                            ></b-form-select>
                            <em>{{formData.criminalRecordVerificationDate | moment('MM-DD-YYYY HH:MM ')}}</em>

                        </b-form-group>
                    </div>
                    <div class="col-md-4">
                            <base-file-input style="margin-bottom: 1px !important;"
                                    inputLabel="Upload File"
                                    :ref="verificationFile"
                                    v-model="formData.verificationFile"
                                    file-type="customers"
                                    accept="image/*, application/pdf"
                                    v-validate="{
            required: false,
        }"
                                    :required="false"
                                    :placeholder="formData.verificationFile"
                                    name="Criminal Record Verification File"
                            ></base-file-input>
                        <a v-if="formData.verificationFile" @click="openPopup(formData.verificationFile)">Preview</a>

                    </div>
                    <div class="col-md-12">
                        <b-form-group label="Idenfo Verification Status">
                            <!-- :label-for="formData.factor" -->
                            <b-form-select
                                    v-model="formData.idenfoVerificationStatus"
                                    :options="options5"
                                    placeholder="Select an Option"
                                    v-validate="{
                                    required: false,
                                }"
                                    class="form-control"
                                    name="Idenfo Verification Status"
                                    :class="{
                                    'is-invalid': errors.has(
                                        'Idenfo Verification Status'
                                    ),
                                }"
                            ></b-form-select>
                        </b-form-group>
                    </div>

                    </div>
                <div class="col-md-12 action-buttons">
                    <base-button
                        btn-label="Update"
                        btn-type="submit"
                        btn-variant="primary"
                        :class="loading ? 'disabled' : ''"
                        :disabled="loading"
                    ></base-button>
                    <base-button
                        btn-label="Cancel"
                        btn-type="reset"
                        :disabled="loading"
                        btn-variant="link"
                    ></base-button>
                </div>
            </b-form>
        </b-modal>




        <b-modal
                id="preview1"
                title="Document Preview"
                size="md"
                ok-only
                ok-title="Close"
                ok-variant="primary"
                no-close-on-backdrop
                no-close-on-esc
        >
            <div class="document-preview-section">
                <div v-if="formData && formData.verificationFile" class="preview-video">
                    <div
                            v-if="getExt(formData.verificationFile) == 'pdf'"
                            class="preview-video text-center identification-section"
                    >
                        <!-- <pdf :src="pdfSrc" @num-pages="0"></pdf> -->

                        <pdf
                                style="display: block"
                                :src="getFilePath(formData.verificationFile)"
                                @num-pages="pageCount = new Array($event)"
                        />
                        <!-- Actual document -->
                        <pdf
                                v-for="(page, index) in pageCount"
                                :key="index"
                                :src="getFilePath(formData.verificationFile)"
                                :page="index + 1"

                        />
                    </div>
                    <div v-else>
                        <img
                                v-authenticated-image="'customers/'+formData.verificationFile"
                                class="image-preview"
                        />
                    </div>
                </div>
            </div>

        </b-modal>



        <b-modal
                id="preview2"
                title="Document Preview"
                size="md"
                ok-only
                ok-title="Close"
                ok-variant="primary"
                no-close-on-backdrop
                no-close-on-esc
        >
            <div class="document-preview-section">
                <div v-if="formData && formData.degreeFile" class="preview-video">
                    <div
                            v-if="getExt(formData.degreeFile) == 'pdf'"
                            class="preview-video text-center identification-section"
                    >
                        <!-- <pdf :src="pdfSrc" @num-pages="0"></pdf> -->

                        <pdf
                                style="display: block"
                                :src="getFilePath(formData.degreeFile)"
                                @num-pages="pageCount = new Array($event)"
                        />
                        <!-- Actual document -->
                        <pdf
                                v-for="(page, index) in pageCount"
                                :key="index"
                                :src="getFilePath(formData.degreeFile)"
                                :page="index + 1"

                        />
                    </div>
                    <div v-else>
                        <img
                                v-authenticated-image="'customers/'+formData.degreeFile"
                                class="image-preview"
                        />
                    </div>
                </div>
            </div>
        </b-modal>

        <b-modal
                id="preview3"
                title="Document Preview"
                size="md"
                ok-only
                ok-title="Close"
                ok-variant="primary"
                no-close-on-backdrop
                no-close-on-esc
        >
            <div class="document-preview-section">
                <div v-for="employmentFile in this.employmentFiles" v-if="employmentFile.file" class="preview-video">
                    <div
                            v-if="getExt(employmentFile.file) == 'pdf'"
                            class="preview-video text-center identification-section"
                    >
                        <!-- <pdf :src="pdfSrc" @num-pages="0"></pdf> -->

                        <pdf
                                style="display: block"
                                :src="getFilePath(employmentFile.file)"
                                @num-pages="pageCount = new Array($event)"
                        />
                        <!-- Actual document -->
                        <pdf
                                v-for="(page, index) in pageCount"
                                :key="index"
                                :src="getFilePath(employmentFile.file)"
                                :page="index + 1"

                        />
                    </div>
                    <div v-else>
                        <img
                                v-authenticated-image="'customers/'+employmentFile.file"
                                class="image-preview"
                        />
                    </div>
                </div>
            </div>
        </b-modal>


        <!-- New General Popup -->
        <b-modal
                id="preview-uploaded-image"
                title="Document Preview"
                size="md"
                ok-only
                ok-title="Close"
                ok-variant="primary"
                no-close-on-backdrop
                no-close-on-esc
                @hide="()=> selectedPreviewItem = ''"
        >
            <div class="document-preview-section">
                <div v-if="selectedPreviewItem" class="preview-video">
                    <div
                            v-if="getExt(selectedPreviewItem) == 'pdf'"
                            class="preview-video text-center identification-section"
                    >
                        <!-- <pdf :src="pdfSrc" @num-pages="0"></pdf> -->

                        <pdf
                                style="display: block"
                                :src="getFilePath(selectedPreviewItem)"
                                @num-pages="pageCount = new Array($event)"
                        />
                        <!-- Actual document -->
                        <pdf
                                v-for="(page, index) in pageCount"
                                :key="index"
                                :src="getFilePath(selectedPreviewItem)"
                                :page="index + 1"

                        />
                    </div>
                    <div v-else>
                        <img
                                v-authenticated-image="'customers/'+selectedPreviewItem"
                                class="image-preview"
                        />
                    </div>
                </div>
            </div>
        </b-modal>

    </div>
</template>

<script>
import { mapGetters } from 'vuex'
const customerVerificationStatusUpdateApi = new resource(
    'customers/update-customer-verification-status'
)
import pdf from 'vue-pdf'

import resource from '@/api/resource'
import BaseFileInput from "../BaseFileInput";

export default {
    components: {BaseFileInput,pdf},
    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            selectedPreviewItem: null,
            formData: this.initializeFormData(),
            criminalRecordDetails:{},
            degreeRecordDetails:{},
            employmentRecordDetails:{},
            options: [
                { value: null, text: 'Select an Option', disabled: true },
                { value: 'matched', text: 'Matched' },
                { value: 'notmatched', text: 'Not Matched' },
            ],
            options2: [
                { value: null, text: 'Select an Option', disabled: true },
                { value: 'notfound', text: 'Not Found' },
                { value: 'found', text: 'Record Found' },
            ],
            options3: [
                { value: null, text: 'Select an Option', disabled: true },
                { value: 'matched', text: 'Verified' },
                { value: 'notmatched', text: 'Not Verified' },
            ],
            options4: [
                { value: null, text: 'Select an Option', disabled: true },
                { value: 'matched', text: 'Verified' },
                { value: 'notmatched', text: 'Not Verified' },
            ],
            options5: [
                { value: null, text: 'Select an Option', disabled: true },
                { value: 'pending', text: 'Pending' },
                { value: 'completed', text: 'Completed' },
                { value: 'high', text: 'High Risk' },
            ],
        }
    },
    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['loading', 'selectedItem', 'hidePopup']),
        employmentFiles(){
          return [{file:this.formData.employmentFile},{file:this.formData.employmentFile2},{file:this.formData.employmentFile3}]
        }

        // title() {
        //     return this.selectedItem
        //         ? 'Modify ' + this.selectedItem.code + ' ' + 'Score'
        //         : 'Add Country of Residence Factor'
        // }, // End of title() method

        // buttonLabel() {
        //     return this.selectedItem ? 'Update' : 'Create'
        // },
    }, // End of Component > methods
    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        /**
         * Handle when the selected has been updated
         *
         * @return {void}
         */
        selectedItem(value) {
            // console.log('Selected Item at Watch : ', value)
            if (value !== null && value !== undefined) {
                console.log('value', value)
                this.formData.verification =
                    value.customerVerificationStatus.nadra === "pending" ? null : value.customerVerificationStatus.nadra
                this.formData.licenseVerification =
                    value.customerVerificationStatus.license === "pending" ? null : value.customerVerificationStatus.license
                this.formData.degreeVerification =
                    value.customerVerificationStatus.degree === "pending" ? null : value.customerVerificationStatus.degree
                this.formData.employmentVerification =
                    value.customerVerificationStatus.employment === "pending" ? null : value.customerVerificationStatus.employment
                this.formData.verificationCriminal =
                    value.customerVerificationStatus.criminalRecordVerification === "pending" ? null : value.customerVerificationStatus.criminalRecordVerification
                this.formData.idenfoVerificationStatus =
                   value.customerVerificationStatus.idenfoVerificationStatus? value.customerVerificationStatus.idenfoVerificationStatus:'pending'
                this.formData.idVerificationFile =
                   value.customerVerificationStatus.idVerificationFile
                this.formData.licenseVerificationFile =
                   value.customerVerificationStatus.licenseVerificationFile

                this.formData.verificationFile =
                   value.customerVerificationStatus.criminalRecordVerificationFile

                this.formData.degreeFile =
                   value.customerVerificationStatus.degreeVerificationFile

                this.formData.employmentFile =
                   value.customerVerificationStatus.employmentVerificationFile
                this.formData.employmentFile2 =
                   value.customerVerificationStatus.employmentVerificationFile2
                   this.formData.employmentFile3 =
                   value.customerVerificationStatus.employmentVerificationFile3

                // assign dates to local variables

                this.formData.idVerificationDate=value.customerVerificationStatus.idVerificationDate
                this.formData.employmentVerificationDate=value.customerVerificationStatus.employmentVerificationDate
                this.formData.licenseVerificationDate=value.customerVerificationStatus.licenseVerificationDate
                this.formData.degreeVerificationDate=value.customerVerificationStatus.degreeVerificationDate
                this.formData.criminalRecordVerificationDate=value.customerVerificationStatus.criminalRecordVerificationDate


                Object.assign(this.formData, value)
            } else {
                this.onHidden()
            }
        },
        /**
         * Handle when the popup hide
         *
         * @return {void}
         */
        hidePopup(value) {
            if (value) {
                this.onHidden()
            }
        },
    }, // End of Component > computed
    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        initializeFormData() {
            return {
                verification: '',
                licenseVerification: '',
                verificationCriminal: '',
                verificationFile:'',
                employmentFile:'',
                employmentFile2:'',
                employmentFile3:'',
                employmentVerification:'',
                degreeVerification:'',
                degreeFile:'',
                idenfoVerificationStatus:'',
                idVerificationFile: '',
                licenseVerificationFile: '',

                idVerificationDate:'',
                licenseVerificationDate:'',
                employmentVerificationDate:'',
                degreeVerificationDate:'',
                criminalRecordVerificationDate:'',
            }
        }, // End of initializeFormData() method
        /**
         * Handle when the modal is closed
         *
         * @return {void}
         */
        onHidden() {
            // clear the selected item
            this.$store.commit('clearItem')
            this.$store.commit('onSubmit', null)
            Object.assign(this.formData, this.initializeFormData())
            this.$validator.reset()
            this.$refs.modal.hide()
        }, // End of onHidden() method
        /**
         * Handle when the modal is canceled
         *
         * @return {void}
         */
        async onSubmit() {
            const result = await this.$validator.validateAll()
            if (result) {
                // this.formData.customerVerificationStatus.nadra =
                //     this.formData.verification
                console.log('this.formData', this.formData)

                try {
                    this.$store.commit('setLoading', true)
                    var { data } =
                        await customerVerificationStatusUpdateApi.update(
                            this.formData.customerId,
                            this.formData
                        )
                    if (data) {
                        this.$toasted.show(data.message, {
                            duration: 2000,
                            type: ['success'],
                        })
                        this.onHidden()
                        // this.$store.commit('setUser', data.data)
                        // this.$store.commit('reloadList', true)
                        // this.apply()
                        this.$emit('statusUpdated', true)
                    }
                    this.$store.commit('setLoading', false)
                } catch (error) {
                    this.$store.commit('setLoading', false)
                    this.$store.commit('setError', error)
                }
                // try {
                //     await this.$store.dispatch('onSubmit', this.formData)
                // } catch (error) {
                //     console.log(error, 'There is an error on submit')
                // }
            } else {
                this.$store.commit('setError', this.errors.all()[0])
            }
        }, // End of onSubmit() method
        // openPopup(id)
        // {
        //     console.log('records -----------' ,this.criminalRecordDetails)
        //     this.$bvModal.show(id)
        // },
        openPopup(selectedPreviewItem)
        {
            this.selectedPreviewItem = selectedPreviewItem;
            this.$bvModal.show("preview-uploaded-image")
        },
        getExt(file)
        {
            return file? file.split('.').pop() : null
        },
        getFilePath(formData) {
            return process.env.VUE_APP_FILE_SERVICE_URL + 'customers/'+formData
        }
    }, // End of Component > watch
}
</script>
